(ns minorodata.connections.model
  (:require [mold.core :as m :include-macros true]
            [minorodata.users.model :refer [searchable-user]]))

(declare ->extract-panel ->extract-task-status ->extract-job
         ->source-connection ->user-connectors ->user-synchronizers
         ->source ->extract ->source-metadata ->filestore-data
         ->filestore-status ->warehouse-data ->sources-panel
         ->warehouse-status ->warehouse-meta)


(m/defmodel warehouse-status
  {:sink        [::m/string ::m/identity "Warehouse type"]
   :sink-status [::m/map "Warehouse status"]}
  {:singleton true})


(m/defmodel warehouse-data
  {:sink-type [::m/string "Warehouse type"]
   :id        [::m/string ::m/identity ::m/req "Warehouse secret id"]
   :json-data [::m/map "Map of connection details"]}
  {:singleton true})


(m/defmodel warehouse-meta
  {:catalogs [::m/vector ::m/nilable "Warehouse metadata catalogs"]
   :schemas  [::m/vector ::m/nilable "Warehouse metadata schemas"]}
  {:singleton true})


(m/defmodel filestore-status
  {:store        [::m/string ::m/identity "Filestore type"]
   :store-status [::m/map "Filestore status"]}
  {:singleton true})


(m/defmodel filestore-data
  {:s3-key         [::m/string "S3 key"]
   :s3-secret      [::m/string "S3 secret"]
   :region         [::m/string "S3 region"]
   :bucket         [::m/string "Default bucket"]
   :sas-token      [::m/string "Azure SAS token"]
   :url            [::m/string "Azure Blob Storage url"]
   :container-name [::m/string "Azure container name"]
   :filestore-requires-ip-whitelist [::m/bool "Filestore IP whitelisting indicator"]

   :client-email   [::m/string "GCS client email"]
   :client-id      [::m/string "GCS client id"]
   :private-key    [::m/string "GCS private key"]
   :private-key-id [::m/string "GCS private key id"]
   :project-id     [::m/string "GCS project id"]}
  {:singleton true})


(m/defmodel source-metadata
  {:metadata              [::m/map "Source metadata"]
   :metadata-schemas      [::m/map "Source metadata schemas"]
   :metadata-tables       [::m/map "Source metadata tables"]
   :metadata-columns      [::m/map "Source metadata columns"]
   :metadata-primary-keys [::m/map "Source metadata primary keys"]
   :table-updated         [::m/bool "Table update flag"]}
  {:singleton true})

(m/defmodel source
  {:source-id   [::m/string ::m/identity "ID"]
   :name        [::m/string ::m/nilable "Source name"]
   :description [::m/string ::m/nilable "Description"]
   :updated-at  [::m/string "Updated at ISO timestamp"]
   :client-id   [::m/string "Client ID (UUID)"]
   :source-type [::m/string "Source Type"]
   :source      [::m/map "Source Configuration"]
   :updated-by  {::m/type     ::m/ref
                 ::m/ref-type searchable-user
                 ::m/doc      "Related user"}
   :created-by  {::m/type     ::m/ref
                 ::m/ref-type searchable-user
                 ::m/doc      "Related user"}
   :active      [::m/number "Active state (why number?)"]
   :created-at  [::m/string "Created at timestamp"]})

(m/defmodel deleted-source
  {:source-id   [::m/string ::m/identity "ID"]
   :name        [::m/string ::m/nilable "Source name"]
   :description [::m/string ::m/nilable "Description"]
   :updated-at  [::m/string "Updated at ISO timestamp"]
   :client-id   [::m/string "Client ID (UUID)"]
   :source-type [::m/string "Source Type"]
   :ingest-id   [::m/string "Ingest ID"]
   :source      [::m/map "Source Configuration"]
   :updated-by  {::m/type     ::m/ref
                 ::m/ref-type searchable-user
                 ::m/doc      "Related user"}
   :created-by  {::m/type     ::m/ref
                 ::m/ref-type searchable-user
                 ::m/doc      "Related user"}
   :active      [::m/number "Active state (why number?)"]
   :created-at  [::m/string "Created at timestamp"]})


(m/defmodel extract
  {:extract-id           [::m/string ::m/req ::m/identity "ID"]
   :master-id            [::m/string "Master ID"]
   :client-id            [::m/string "Client ID"]
   :source-id            [::m/string "Source ID"]
   :task-definition-name [::m/string ::m/nilable "Task definition name"]
   :name                 [::m/string "Extract name"]
   :description          [::m/string ::m/nilable "Description"]
   :status               {::m/type ::m/enum
                          ::m/vals #{"active" "paused"}
                          ::m/doc  "Extract status"}
   :output-tables        {::m/type        ::m/string
                          ::m/cardinality ::m/many
                          ::m/doc         "Output tables"}
   :downstream-config    [::m/string ::m/nilable "#{nil 'full'}"]
   :source               [::m/map "Extract configuration json"]
   :updated-at           [::m/string "Timestamp"]
   :created-at           [::m/string "Timestamp"]

   :updated-by           {::m/type     ::m/ref
                          ::m/ref-type searchable-user
                          ::m/doc      "Related user"}
   :created-by           {::m/type     ::m/ref
                          ::m/ref-type searchable-user
                          ::m/doc      "Related user"}

   ;; Temporal schedule
   :schedule-spec        [::m/map ::m/nilable "Schedule spec"]

   :order                [::m/number ::m/nilable "Order of the extract in the panel"]})

(m/defmodel deleted-extract
  {:extract-id           [::m/string ::m/req ::m/identity "ID"]
   :master-id            [::m/string "Master ID"]
   :client-id            [::m/string "Client ID"]
   :source-id            [::m/string "Source ID"]
   :task-definition-name [::m/string ::m/nilable "Task definition name"]
   :name                 [::m/string "Extract name"]
   :description          [::m/string ::m/nilable "Description"]
   :status               {::m/type ::m/enum
                          ::m/vals #{"active" "paused"}
                          ::m/doc  "Extract status"}
   :output-tables        {::m/type        ::m/string
                          ::m/cardinality ::m/many
                          ::m/doc         "Output tables"}
   :downstream-config    [::m/string ::m/nilable "#{nil 'full'}"]
   :source               [::m/map "Extract configuration json"]
   :updated-at           [::m/string "Timestamp"]
   :created-at           [::m/string "Timestamp"]

   :updated-by           {::m/type     ::m/ref
                          ::m/ref-type searchable-user
                          ::m/doc      "Related user"}
   :created-by           {::m/type     ::m/ref
                          ::m/ref-type searchable-user
                          ::m/doc      "Related user"}

   ;; Temporal schedule
   :schedule-spec        [::m/map ::m/nilable "Schedule spec"]

   :order                [::m/number ::m/nilable "Order of the extract in the panel"]})

(m/defmodel extract-panel
  {:source-id      [::m/string "Source ID"]
   :items          {::m/type        ::m/ref
                    ::m/cardinality ::m/many
                    ::m/ref-type    extract}
   :pagination     [::m/map "Pagination map"]
   :sort           [::m/map "Sort map"]}
  {:singleton true})

(m/defmodel sources-panel
  {:sources   {::m/type ::m/ref
               ::m/cardinality ::m/many
               ::m/ref-type source}
   :order-by  [::m/keyword ::m/nilable]
   :order-dir [::m/keyword ::m/nilable]}
  {:singleton true})

(m/defmodel extract-task-status
  {:extract-id [::m/string ::m/req ::m/identity "ID"]
   :client-id  [::m/string "Client ID"]
   :source-id  [::m/string "Source ID"]
   :status     [::m/string "Actual task status"]
   :created-at [::m/string "Date of creation"]})


(m/defmodel extract-job
  {:id           [::m/identity ::m/req ::m/string "Job id"]
   :name         [::m/string "job (extract) name"]
   :execution-id [::m/string "Job execution id"]
   :status       [::m/keyword "Job status"]
   :errors       [::m/map ::m/nilable "Job errors"]
   :start-time   [::m/string ::m/nilable "Job start time"]
   :end-time     [::m/string ::m/nilable "Job end time"]
   :extract      [::m/string "Extract ID"]})


(m/defmodel connector
  {:action [::m/keyword "Action to perform on the connector"]
   :type   [::m/string "Selected connector type"]
   :id     [::m/string "Selected connector id"]
   :meta   [::m/map ::m/nilable "Misc data"]}
  {:singleton true})


(m/defmodel user-connectors
  {:list [::m/vector "A list of all accessible connectors (source and form definitions)"]}
  {:singleton true})


(m/defmodel user-synchronizers
  {:list [::m/vector "A list of all synchronizers sources"]}
  {:singleton true})


(m/defmodel source-connection
  {:connection-status [::m/keyword "API connection status (:connected :failed)"]
   :connection-message [::m/map "The body of the response from the API"]}
  {:singleton true})
